import { render } from "./RelatorioStatusManual.vue?vue&type=template&id=2d6e2615&scoped=true"
import script from "./RelatorioStatusManual.vue?vue&type=script&lang=js"
export * from "./RelatorioStatusManual.vue?vue&type=script&lang=js"

import "./RelatorioStatusManual.vue?vue&type=style&index=0&id=2d6e2615&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d6e2615"]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QCard,QCardSection,QSeparator,QCardActions,QBtn});qInstall(script, 'directives', {ClosePopup});
